import React from 'react';
import { SectionPlaceholder } from '../../Placeholders/SectionPlaceholder';
import { ItemCardPlaceholder } from '../../Placeholders/ItemCardPlaceholder';

const DESK_PASHA_CARDS_IN_ROW = 5;
const DESK_PASHA_CARD_ROWS = 2;
const MOB_PASHA_CARD_ROWS = 3;
const EXTRA_SMALL_MOB_CARD_ROWS = 6;

const getRowCount = (isExtraSmall: boolean, isSmall: boolean) => {
  if (isExtraSmall) return EXTRA_SMALL_MOB_CARD_ROWS;
  if (isSmall) return MOB_PASHA_CARD_ROWS;
  return DESK_PASHA_CARD_ROWS;
};

interface CardPlaceholderProps {
  isLarge: boolean;
  isSmall: boolean;
  isExtraSmall: boolean;
}

export const CardPlaceholder: React.FC<CardPlaceholderProps> = ({
  isLarge,
  isSmall,
  isExtraSmall
}) => (
  <SectionPlaceholder
    rowCount={getRowCount(isExtraSmall, isSmall)}
    deskRowCount={DESK_PASHA_CARDS_IN_ROW}
    noHeader
  >
    {Array.from(
      { length: isLarge ? DESK_PASHA_CARDS_IN_ROW : MOB_PASHA_CARD_ROWS },
      (_, index) => (
        <ItemCardPlaceholder key={index} isCardsLayout />
      )
    )}
  </SectionPlaceholder>
);
